import { usePageEditorStore } from '@/stores/page-editor-store';

export function useIsPageActive(pageId: string): boolean {
  return usePageEditorStore((state) => {
    const activePageId = state.previewNavigationPage?.id ?? state.page?.id ?? null;
    return activePageId === pageId;
  });
}
